// ABOUTME: Rule and hook telling whether the current user may open the Hierarchies page, driven by
// ABOUTME: the hierarchiesPageRoles system setting (absent = everyone, admins always pass).

import { useAuth } from '@src/hooks';
import { SettingsContext } from '@src/modules/setting/SettingsContext';
import { useContext } from 'react';

export const HIERARCHIES_ADMIN_ROLES = ['PIM_ADMIN', 'PIM_SUPERADMIN'];

/**
 * Absent or null `allowedRoles` = every user; an empty list = admins only.
 * PIM_ADMIN and PIM_SUPERADMIN always pass.
 */
export const canAccessHierarchies = (
    allowedRoles: string[] | null | undefined,
    hasUserRole: (role: string) => boolean,
): boolean => {
    if (allowedRoles == null) return true;
    if (HIERARCHIES_ADMIN_ROLES.some(role => hasUserRole(role))) return true;
    return allowedRoles.some(role => hasUserRole(role));
};

export function useCanAccessHierarchies(): boolean {
    const { hierarchiesPageRoles } = useContext(SettingsContext);
    const { hasUserRole } = useAuth();

    return canAccessHierarchies(hierarchiesPageRoles, hasUserRole);
}
